import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, { bg: string; text: string; hover: string }> = {
  primary: {
    bg: 'bg-primary-50',
    text: 'text-primary-700',
    hover: 'hover:bg-primary-100',
  },
  accent: {
    bg: 'bg-accent-50',
    text: 'text-accent-700',
    hover: 'hover:bg-accent-100',
  },
  secondary: {
    bg: 'bg-secondary-50',
    text: 'text-secondary-700',
    hover: 'hover:bg-secondary-100',
  },
};

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-4">
            探索内容分类
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            无论你是新手冒险者还是资深玩家，这里都有你想要的内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group block p-6 rounded-xl ${colors.bg} ${colors.hover} transition-all duration-300 cursor-pointer`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${colors.bg} mb-4`}>
                  <i className={`${cat.icon} text-2xl ${colors.text}`}></i>
                </div>
                <h3 className={`font-heading text-xl ${colors.text} mb-2`}>{cat.name}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
                <div className="mt-4 flex items-center gap-1 text-sm font-medium text-foreground-500 group-hover:text-foreground-700 transition-colors">
                  <span>浏览内容</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}